import React, { useState, useEffect, Fragment } from 'react';
import { useHistory, Link } from 'react-router-dom';
import Select from 'react-select';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Tooltip, Button, CircularProgress
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CopyrightIcon from '@mui/icons-material/Copyright';
// Assume fetchData and postData are defined elsewhere
import { fetchData, updateData, postData } from '../../../apiService';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import AddIcon from "@mui/icons-material/Add";
import AsyncSelect from "react-select/async";  // ? instead of AsyncCreatableSelect
import AsyncCreatableSelect from 'react-select/async-creatable';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa'; // Example for FontAwesome Icon
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { toWords } from 'number-to-words';
import Logo from './../Logo/QR.png';

import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Checkbox,
} from "@mui/material";

const ProformaCreate = () => {
    const history = useHistory();
    const { isAuthenticated, companyId, userId, permissions, token, logout, branchstate, branchId } = useAuth();
    const [defaultFreightGSTRate, setdefaultFreightGSTRate] = useState(0);
    const [defaultPackingGSTRate, setdefaultPackingGSTRate] = useState(0);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated]);

    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        const today = new Date().toISOString().split('T')[0];
        setFormData(prev => ({ ...prev, InvoiceDate: today }));
    }, []);

    const [formData, setFormData] = useState({
        CompanyId: companyId,
        CreatedBy: userId,
        CreatedDate: new Date().toISOString(),
        CashAmount: '0.00',
        CardAmount: '0.00',
        UPIAmount: '0.00',
        BalanceAmount: '0.00',
        IsWholeSaleRate: false,
    });

    // For Customer Select
    const [supplierOptions, setSupplierOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedInvoiceType, setSelectedInvoiceType] = useState("");
    const [dropdownInvoiceTypeOptions, setDropdownInvoiceTypeOptions] = useState([]);
    const [dropdownStateCodeOptions, setDropdownStateCodeOptions] = useState([]);
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [selectedSalesMan, setSelectedSalesMan] = useState("");
    const [selectedStateCode, setSelectedStateCode] = useState("");
    const [dropdownSalesManOptions, setDropdownSalesManOptions] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [collectedAmount, setCollectedAmount] = useState(0);
    const [balanceAmount, setBalanceAmount] = useState(0);

    // Helper function to parse and handle NaN values as 0
    const parseAndFix = (val) => parseFloat(val) || 0;

    const handleInputChange = (newValue) => newValue;

    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };

    useEffect(() => {
        fetchInvoicetypeData();
        fetchDropdownSalesManOptions();
        fetchfrightrate();
        fetchStateCodeData();
    }, []);

    const fetchStateCodeData = () => {
        fetchData('SaleApi', `/StateCode/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownStateCodeOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Disc Type dropdown options:', error);
            });
    };

    const fetchfrightrate = () => {
        fetchData('CompanyApi', `/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {

                setFormData(prevData => ({
                    ...prevData,
                    FreightGSTRate: data[0].FreightGSTRate,
                    PackingGSTRate: data[0].FreightGSTRate,
                    DispatchFrom: data[0].Name,
                    DispatchAddress1: data[0].AddressLine1,
                    DispatchAddress2: data[0].AddressLine2,
                    DispatchLocation: data[0].Location,
                    DispatchPincode: data[0].PinCode,
                    TransporterName: data[0].Name,
                    TransporterGST: data[0].GSTNumber,
                }));
                setdefaultFreightGSTRate(data[0].FreightGSTRate);
                setdefaultPackingGSTRate(data[0].FreightGSTRate);
            })
            .catch((error) => {
                console.error('Error fetching options:', error);
            });
    };

    //FOR GET InvoicetypeData  Details FROM API
    const fetchInvoicetypeData = () => {
        fetchData('SaleApi', `/InvoiceType/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownInvoiceTypeOptions(data);

                const currentDate = new Date();
                const year = currentDate.getFullYear();
                const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                const day = String(currentDate.getDate()).padStart(2, '0');
                const formattedDate = `${year}-${month}-${day}`;

                setFormData(prevData => ({
                    ...prevData,
                    BillDate: formattedDate,
                    CompanyId: companyId,
                    CreatedBy: userId,
                }));
            })
            .catch((error) => {
                console.error('Error fetching Disc Type dropdown options:', error);
            });
    };

    // FOR Sales MAn 

    const fetchDropdownSalesManOptions = () => {
        fetchData('SaleApi', `/SalesMan/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownSalesManOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Sales Man dropdown options:', error);
            });
    };

    const fetchOptions = async (inputValue) => {
        if (inputValue.length <= 2) {
            return [];
        }

        try {
            const response = await fetchData('SaleApi', `/Customer/${companyId}/${inputValue}`, token);
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                if (Array.isArray(data)) {
                    setSupplierOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.Name,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching options:', error);
            return [];
        }
    };

    const handleCustomerSelect = (selectedOption) => {
        setSelectedOption(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            MasterId: selectedOption ? selectedOption.value : '',
            CreatedBy: userId,
        }));

        if (!selectedOption) return;

        const selectedItemId = selectedOption.value;
        const selectedSupplierRetail = supplierOptions.find((itemDetail) => itemDetail.Id === selectedItemId);
        const suppliergstno = selectedSupplierRetail?.GSTNumber ?? '';
        const supplieraddress1 = (selectedSupplierRetail?.AddressLine1 ?? '');
        const supplieraddress2 = (selectedSupplierRetail?.AddressLine2 ?? '');
        const deliveryAddressLine1 = (selectedSupplierRetail?.DeliveryAddressLine1 ?? '');
        const deliveryAddressLine2 = (selectedSupplierRetail?.DeliveryAddressLine2 ?? '');
        const suppliercontactno = selectedSupplierRetail?.ContactNumber1 ?? '';
        const supplierlocation = selectedSupplierRetail?.Location ?? '';
        const supplierpincode = selectedSupplierRetail?.PinCode ?? '';
        const supplierName = selectedSupplierRetail?.Name ?? '';

        let invoiceTypeId = 2; // Default to B To C
        let gstNumber = '';

        if (!suppliergstno) {
            gstNumber = '';
            invoiceTypeId = 2;
            setSelectedInvoiceType({
                value: 2,
                label: 'B To C'
            });
        } else {
            const gstNumberPrefix = suppliergstno.substring(0, 2);
            if (gstNumberPrefix !== branchstate) {
                invoiceTypeId = 3; // IGST
                gstNumber = suppliergstno;
                setSelectedInvoiceType({
                    value: 3,
                    label: 'IGST'
                });
            } else {
                invoiceTypeId = 1; // B To B
                gstNumber = suppliergstno;
                setSelectedInvoiceType({
                    value: 1,
                    label: 'B To B'
                });
            }
        }

        setFormData((prevData) => ({
            ...prevData,
            InvoiceTypeId: invoiceTypeId,
            InvoiceTypeName: invoiceTypeId === 2 ? 'B To C' : invoiceTypeId === 3 ? 'IGST' : 'B To B',
            GSTNumber: gstNumber,
            CustomerAddress: supplieraddress1 + ' ' + supplieraddress2,
            ContactNumber: suppliercontactno,
            CustomerName: supplierName,
            ShipTo: supplierName,
            ShipGSTNo: suppliergstno,
            ShipToAddress1: deliveryAddressLine1,
            ShipToAddress2: deliveryAddressLine2,
            ShipToPincode: supplierpincode,
            ShipToLocation: supplierlocation,
            CreatedBy: userId,
        }));
        fetchmaxbillno(invoiceTypeId);
        //fetchLedgerbal(selectedOption ? selectedOption.value : '',);
    };
    // FOR Max Bill No
    const fetchmaxbillno = (invtype) => {
        const customerid = formData.MasterId !== null ? formData.MasterId : 0;
        fetchData('ProformaApi', `/MaxBillno/${companyId}/${invtype}`, token)
            .then((response) => response.response_data)
            .then((data) => {

                const currentDate = new Date();
                const year = currentDate.getFullYear();
                const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                const day = String(currentDate.getDate()).padStart(2, '0');
                const formattedDate = `${year}-${month}-${day}`;

                setFormData(prevData => ({
                    ...prevData,
                    BillNumber: data.BillNumber,
                    BillDate: formattedDate,
                    FinYear: data.FinYear,
                    CompanyId: companyId,
                    FreightGSTRate: data.FreightGSTRate,
                    PackingGSTRate: data.PackingGSTRate,
                    BillPrefix: data.BillPrefix,
                }));

                setdefaultFreightGSTRate(data.FreightGSTRate);
                setdefaultPackingGSTRate(data.PackingGSTRate);
            })
            .catch((error) => {
                console.error('Error fetching Max Billno', error);
            });


    };



    //// modalData 
    // FOR MODEL DATA (Invoice Details)
    const [selectedItemOption, setSelectedItemOption] = useState(null);

    const [modalData, setModalData] = useState({
        SlNo: '0',
        ItemName: '',
        ItemName1: '',
        ItemId: '',
        Quantity: '',
        Rate: '',
        Amount: '',
        TaxableAmount: '',
        GSTRate: '',
        GSTAmount: '',
        TotalAmount: '',
        BalanceStock: '0',
    });

    const closeModal = () => {
        setModalData({
            SlNo: '0',
            ItemName: '',
            ItemName1: '',
            ItemId: '',
            Quantity: '',
            Rate: '',
            Amount: '',
            GSTRate: '',
            GSTAmount: '',
            TotalAmount: '',
            BalanceStock: '0',
        });
    };

    const saveModalData = () => {
        let isValid = true;
        let errors = "";
        setErrorMessageModel(errors);

        // Validation for ItemId
        if (!modalData.ItemId) {
            isValid = false;
            errors = "Item is required";
        }

        // Validation for Quantity
        if (!modalData.Quantity || isNaN(modalData.Quantity)) {
            isValid = false;
            errors = "Quantity must be a valid number";
        }


        // Prevent duplicate item with same rate
        const duplicateExists = selectedItems.some(
            item => item.ItemId === modalData.ItemId && parseFloat(item.Rate) === parseFloat(modalData.Rate)
        );

        if (duplicateExists) {
            alert("This item with the same rate is already added.");
            return;
        }

        if (isValid) {
            //setInvoicedeatils([...invoicedeatils, modalData]);
            const updatedInvoicedetails = [...selectedItems, modalData];
            const updatedInvoicedetailsSorted = updatedInvoicedetails.reverse();
            setSelectedItems(updatedInvoicedetailsSorted);

            setModalData({
                ...modalData,
                SlNo: '0',
                ItemName: '',
                ItemName1: '',
                ItemId: '',
                Quantity: '',
                Rate: '',
                SaleRate: '',
                WholeSaleRate: '',
                Amount: '',
                GSTRate: '',
                GSTAmount: '',
                TotalAmount: '',
                BalanceStock: '0',
            });

            setSelectedItemOption(null); // Clear AsyncSelect
            fetchItemOptions('');
            //closeModal();

            //Update the totals based on the updatedItemData
            const Quantity = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const CGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);

            const TaxableAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);


            let FreightAmount = parseFloat(formData.FreightAmount) || 0;
            let PackingAmount = parseFloat(formData.PackingAmount) || 0;
            let TCSAmount = parseFloat(formData.TCSAmount) || 0;
            let DiscountAmount = parseFloat(formData.DiscountAmount) || 0;
            let CashAmount = parseAndFix(formData.CashAmount) || 0;
            let CardAmount = parseAndFix(formData.CardAmount) || 0;
            let UPIAmount = parseAndFix(formData.UPIAmount) || 0;


            totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, FreightAmount, PackingAmount, TCSAmount, CashAmount, CardAmount, UPIAmount);
        } else {

            console.log("Validation errors:", errors);
            // setErrorMessageModel(errors);
        }

    };

    const [showModal, setShowModal] = useState(false);

    const opendatamodal = () => {
        setShowModal(true);
    };

    const closeDataModal = () => {
        console.log('Closing modal');
        setShowModal(false);
    };


    // --- STATES ---
    const [itemsOptions, setItemsOptions] = useState([]);
    const handleItemChange = (newValue) => newValue;
    // --- FETCH OPTIONS ---
    const fetchItemOptions = async (inputValue = '') => {
        if (!inputValue || inputValue.length <= 1) return [];

        const customerid = 0; // Replace if needed

        try {
            const response = await fetchData('SaleApi', `/Item/${companyId}/${customerid}/${inputValue}`, token);

            if (response.responseCode === '1111') {
                const data = response.response_data || [];
                if (Array.isArray(data)) {
                    setItemsOptions(data);
                    return data.map((item) => ({
                        value: item.Id,
                        label: item.ItemName1,
                    }));
                }
            }
            return [];
        } catch (error) {
            console.error('Error fetching item options:', error);
            return [];
        }
    };

    // --- MAIN CHANGE HANDLER ---
    const handleChangeDrop = async (selectedOption) => {
        setSelectedItemOption(selectedOption);

        if (!selectedOption) {
            // reset
            setModalData({
                ...modalData,
                Rate: '',
                SaleRate: '',
                WholeSaleRate: '',
                GSTRate: '0.00',
                ItemName: '',
                ItemName1: '',
                ItemId: '',
                TaxableAmount: '0.00',
                CGSTAmount: '0.00',
                SGSTAmount: '0.00',
                IGSTAmount: '0.00',
                TotalAmount: '0.00',
                GSTAmt: '0.00',
                Quantity: '',
                BalanceStock: '0',
            });
            return;
        }

        // ?? Get item detail immediately � from state or API
        let selectedItemDetail = itemsOptions.find((item) => item.Id === selectedOption.value);

        if (!selectedItemDetail) {
            // ? Fallback: fetch that single item from API (guaranteed to exist)
            try {
                const customerid = 0;
                const res = await fetchData('SaleApi', `/Item/${companyId}/${customerid}/${selectedOption.label}`, token);
                if (res.responseCode === '1111' && Array.isArray(res.response_data)) {
                    selectedItemDetail = res.response_data.find((x) => x.Id === selectedOption.value);
                }
            } catch (err) {
                console.error('Error fetching fallback item:', err);
            }
        }

        if (!selectedItemDetail) {
            console.warn('Item detail not found even after fallback:', selectedOption);
            return;
        }

        // --- CALCULATIONS ---
        const quantity = 1;
        const SaleRate = parseFloat(selectedItemDetail.SaleRate || 0);
        const WholeSaleRate = parseFloat(selectedItemDetail.WholeSaleRate || 0);
        const cgstRate = parseFloat(selectedItemDetail.CGSTRate || 0);
        const sgstRate = parseFloat(selectedItemDetail.SGSTRate || 0);
        const rate = SaleRate;

        const saleRateExclGST = (rate / (1 + (cgstRate + sgstRate) / 100)).toFixed(2);
        const taxableAmount = (quantity * saleRateExclGST).toFixed(2);

        let cgstAmt = 0, sgstAmt = 0, igstAmt = 0;

        if (formData.InvoiceTypeId === 3 || formData.InvoiceTypeId === 4) {
            igstAmt = ((taxableAmount * (cgstRate + sgstRate)) / 100).toFixed(2);
        } else {
            cgstAmt = ((taxableAmount * cgstRate) / 100).toFixed(2);
            sgstAmt = ((taxableAmount * sgstRate) / 100).toFixed(2);
        }

        const gstAmt = (
            parseFloat(cgstAmt) + parseFloat(sgstAmt) + parseFloat(igstAmt)
        ).toFixed(2);

        const totalAmount = (
            parseFloat(taxableAmount) + parseFloat(gstAmt)
        ).toFixed(2);

        // --- UPDATE MODAL DATA ---
        setModalData({
            ...modalData,
            Rate: rate.toFixed(2),
            SaleRate: SaleRate.toFixed(2),
            WholeSaleRate: WholeSaleRate.toFixed(2),
            Amount: (quantity * rate).toFixed(2),
            GSTRate: (cgstRate + sgstRate).toFixed(2),
            ItemName: selectedItemDetail.ItemName,
            ItemName1: selectedItemDetail.ItemName1,
            ItemId: selectedItemDetail.Id,
            HSNCode: selectedItemDetail.HSNCode,
            TaxableAmount: taxableAmount,
            CGSTAmount: cgstAmt,
            SGSTAmount: sgstAmt,
            IGSTAmount: igstAmt,
            TotalAmount: totalAmount,
            GSTAmt: gstAmt,
            Quantity: quantity,
            BalanceStock: selectedItemDetail.BalanceStock || '0',
        });
    };


    const handleModalInputChange = (event, itemIndex = null) => {
        const { name, type, checked, value } = event.target;
        const newValue = type === "checkbox" ? checked : value;

        // Step 1: Update modal data
        setModalData((prevData) => {
            const useWholeSaleRate =
                name === "IsWholeSaleRate" ? newValue : prevData.IsWholeSaleRate;

            // Pick correct rate (use wholesale or normal)
            const rateSource = useWholeSaleRate
                ? parseFloat(prevData.WholeSaleRate || 0)
                : parseFloat(prevData.SaleRate || 0);

            let updatedData = {
                ...prevData,
                [name]: newValue,
            };

            if (["Quantity", "Rate", "IsWholeSaleRate"].includes(name)) {
                const quantity =
                    parseFloat(name === "Quantity" ? newValue : prevData.Quantity) || 0;
                const rate =
                    parseFloat(name === "Rate" ? newValue : rateSource) || 0;

                const cgstrate = parseFloat(prevData.GSTRate / 2) || 0;
                const sgstrate = parseFloat(prevData.GSTRate / 2) || 0;

                const amt = (quantity * rate).toFixed(2);
                const salerate = (
                    rate / (1 + (cgstrate + sgstrate) / 100)
                ).toFixed(2);
                const amount = (quantity * salerate).toFixed(2);

                let cgstamt = 0,
                    sgstamt = 0,
                    igstamt = 0;

                if (formData.InvoiceTypeId === 3 || formData.InvoiceTypeId === 4) {
                    igstamt = ((amount * (cgstrate + sgstrate)) / 100).toFixed(2);
                } else {
                    cgstamt = ((amount * cgstrate) / 100).toFixed(2);
                    sgstamt = ((amount * sgstrate) / 100).toFixed(2);
                }

                const gstamt = (
                    parseFloat(cgstamt) +
                    parseFloat(sgstamt) +
                    parseFloat(igstamt)
                ).toFixed(2);

                const totalAmount = (
                    parseFloat(amount) +
                    parseFloat(cgstamt) +
                    parseFloat(sgstamt) +
                    parseFloat(igstamt)
                ).toFixed(2);

                // Update default GST values
                setdefaultFreightGSTRate(
                    Math.max(defaultFreightGSTRate, prevData.GSTRate)
                );
                setdefaultPackingGSTRate(
                    Math.max(defaultPackingGSTRate, prevData.GSTRate)
                );

                updatedData = {
                    ...updatedData,
                    Rate: rate,
                    Quantity: quantity,
                    Amount: amt,
                    TaxableAmount: amount,
                    CGSTAmount: cgstamt,
                    SGSTAmount: sgstamt,
                    IGSTAmount: igstamt,
                    TotalAmount: totalAmount,
                    GSTAmt: gstamt,
                    IsWholeSaleRate: useWholeSaleRate,
                };
            }

            // ? Sync IsWholeSaleRate into formData also
            if (name === "IsWholeSaleRate") {
                setFormData((prevForm) => ({
                    ...prevForm,
                    IsWholeSaleRate: newValue,
                }));
            }

            return updatedData;
        });

        // Step 2: Update selectedItems
        setSelectedItems((prevDetails) => {
            let updatedDetails = [...prevDetails];

            if (itemIndex !== null) {
                updatedDetails[itemIndex] = {
                    ...updatedDetails[itemIndex],
                    [name]: newValue,
                };
            }

            // Recalculate all items with fresh formData wholesale flag
            const recalculatedItems = updatedDetails.map((item) =>
                calculateItemData(
                    {
                        ...item,
                        IsWholeSaleRate:
                            name === "IsWholeSaleRate" ? newValue : item.IsWholeSaleRate,
                    },
                    {
                        ...formData,
                        IsWholeSaleRate:
                            name === "IsWholeSaleRate" ? newValue : formData.IsWholeSaleRate,
                    }
                )
            );

            // Recalculate totals
            const totals = recalculatedItems.reduce(
                (acc, item) => {
                    acc.Quantity += parseAndFix(item.Quantity);
                    acc.Amount += parseAndFix(item.Amount);
                    acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                    acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                    acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                    acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                    acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                    acc.TotalAmount += parseAndFix(item.TotalAmount);
                    return acc;
                },
                {
                    Quantity: 0,
                    Amount: 0,
                    DiscountAmount: 0,
                    TaxableAmount: 0,
                    CGSTAmount: 0,
                    SGSTAmount: 0,
                    IGSTAmount: 0,
                    TotalAmount: 0,
                }
            );

            totalCalculation(
                totals.Quantity,
                totals.Amount,
                totals.DiscountAmount,
                totals.TaxableAmount,
                totals.CGSTAmount,
                totals.SGSTAmount,
                totals.IGSTAmount,
                totals.TotalAmount,
                parseAndFix(formData.FreightAmount),
                parseAndFix(formData.PackingAmount),
                parseAndFix(formData.TCSAmount),
                parseAndFix(formData.CashAmount) || 0,
                parseAndFix(formData.CardAmount) || 0,
                parseAndFix(formData.UPIAmount) || 0
            );

            return recalculatedItems;
        });
    };

    // FOR Calculation
    const totalCalculation = (Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, FreightAmount, PackingAmount, TCSAmount, CashAmount, CardAmount, UPIAmount) => {

        let freightGSTRate = parseAndFix(formData.FreightGSTRate);
        let packingGSTRate = parseAndFix(formData.PackingGSTRate);
        freightGSTRate = Math.max(freightGSTRate, parseAndFix(defaultFreightGSTRate));
        packingGSTRate = Math.max(packingGSTRate, parseAndFix(defaultFreightGSTRate));

        let freightGSTAmount = ((FreightAmount * freightGSTRate) / 100).toFixed(2);
        let packingGSTAmount = ((PackingAmount * packingGSTRate) / 100).toFixed(2);

        let netAmount = parseAndFix(TaxableAmount) + parseAndFix(CGSTAmount) + parseAndFix(SGSTAmount) + parseAndFix(IGSTAmount) + parseAndFix(FreightAmount) + parseAndFix(PackingAmount) + parseAndFix(freightGSTAmount) + parseAndFix(packingGSTAmount) + parseAndFix(TCSAmount);
        let roundOff = Math.round(netAmount) - netAmount;
        let grandTotal = netAmount + roundOff;
        let balhamt = parseFloat(grandTotal - (parseAndFix(CashAmount) + parseAndFix(CardAmount) + parseAndFix(UPIAmount)));

        setFormData((prev) => ({
            ...prev,
            TotalQuantity: Quantity,
            TotalAmount: Amount.toFixed(2),
            TaxableAmount: TaxableAmount.toFixed(2),
            CGSTAmount: CGSTAmount.toFixed(2),
            SGSTAmount: SGSTAmount.toFixed(2),
            IGSTAmount: IGSTAmount.toFixed(2),
            RoundOff: roundOff.toFixed(2),
            GrandTotal: grandTotal.toFixed(2),
            BalanceAmount: balhamt.toFixed(2),
            DiscountAmount: DiscountAmount,
            FreightGSTAmount: freightGSTAmount,
            PackingGSTAmount: packingGSTAmount,
            ModifiedBy: userId,
            FreightGSTRate: freightGSTRate,
            PackingGSTRate: packingGSTRate,
        }));
    };

    const handleCalculation = (e, index, inputType) => {
        let name, value;
        if (typeof e === 'object') {
            name = e.target.name;
            value = e.target.value; // Keep as string to allow user to type freely
        } else {
            name = inputType;
            value = e;
        }

        setSelectedItems((prevDetails) => {
            const updatedDetails = [...prevDetails];
            const currentItem = { ...updatedDetails[index] };

            // -------------------------------
            // Handle Discount calculations
            // -------------------------------
            const rate = parseFloat(currentItem.Rate) || 0;
            const quantity = parseFloat(currentItem.Quantity) || 0;
            const amount = rate * quantity;

            if (name === "DiscountPercentage") {
                currentItem.DiscountPercentage = value;

                const discPercent = parseFloat(value);
                if (!isNaN(discPercent)) {
                    currentItem.DiscountAmount = ((amount * discPercent) / 100).toFixed(2);
                } else {
                    currentItem.DiscountAmount = "";
                }
            }
            else if (name === "DiscountAmount") {
                currentItem.DiscountAmount = value; // let user type freely
                // Don't automatically calculate percentage when typing discount amount
                // The percentage will be calculated only when the field loses focus
            }
            else {
                // Update other fields normally
                currentItem[name] = value;
            }

            // -------------------------------
            // Recalculate all dependent values
            // -------------------------------
            updatedDetails[index] = currentItem;

            const updatedItemData = updatedDetails.map((item) =>
                calculateItemData(item, formData)
            );

            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseAndFix(item.Quantity);
                    acc.Amount += parseAndFix(item.Amount);
                    acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                    acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                    acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                    acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                    acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                    acc.TotalAmount += parseAndFix(item.TotalAmount);
                    return acc;
                },
                {
                    Quantity: 0,
                    Amount: 0,
                    DiscountAmount: 0,
                    TaxableAmount: 0,
                    CGSTAmount: 0,
                    SGSTAmount: 0,
                    IGSTAmount: 0,
                    TotalAmount: 0,
                }
            );

            const FreightAmount = parseAndFix(formData.FreightAmount);
            const PackingAmount = parseAndFix(formData.PackingAmount);
            const TCSAmount = parseAndFix(formData.TCSAmount);
            const CashAmount = parseAndFix(formData.CashAmount) || 0;
            const CardAmount = parseAndFix(formData.CardAmount) || 0;
            const UPIAmount = parseAndFix(formData.UPIAmount) || 0;

            totalCalculation(
                totals.Quantity,
                totals.Amount,
                totals.DiscountAmount,
                totals.TaxableAmount,
                totals.CGSTAmount,
                totals.SGSTAmount,
                totals.IGSTAmount,
                totals.TotalAmount,
                FreightAmount,
                PackingAmount,
                TCSAmount,
                CashAmount,
                CardAmount,
                UPIAmount
            );

            return updatedItemData;
        });
    };

    // New function to handle discount amount blur (when user finishes typing)
    const handleDiscountAmountBlur = (e, index) => {
        const value = e.target.value;
        
        setSelectedItems((prevDetails) => {
            const updatedDetails = [...prevDetails];
            const currentItem = { ...updatedDetails[index] };

            const rate = parseFloat(currentItem.Rate) || 0;
            const quantity = parseFloat(currentItem.Quantity) || 0;
            const amount = rate * quantity;

            const discAmt = parseFloat(value);
            if (!isNaN(discAmt) && amount > 0) {
                // Calculate percentage only when user finishes typing
                currentItem.DiscountPercentage = ((discAmt / amount) * 100).toFixed(2);
            } else if (value === "" || isNaN(discAmt)) {
                currentItem.DiscountPercentage = "";
            }

            // Update in array
            updatedDetails[index] = currentItem;

            const updatedItemData = updatedDetails.map((item) =>
                calculateItemData(item, formData)
            );

            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseAndFix(item.Quantity);
                    acc.Amount += parseAndFix(item.Amount);
                    acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                    acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                    acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                    acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                    acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                    acc.TotalAmount += parseAndFix(item.TotalAmount);
                    return acc;
                },
                {
                    Quantity: 0,
                    Amount: 0,
                    DiscountAmount: 0,
                    TaxableAmount: 0,
                    CGSTAmount: 0,
                    SGSTAmount: 0,
                    IGSTAmount: 0,
                    TotalAmount: 0,
                }
            );

            const FreightAmount = parseAndFix(formData.FreightAmount);
            const PackingAmount = parseAndFix(formData.PackingAmount);
            const TCSAmount = parseAndFix(formData.TCSAmount);
            const CashAmount = parseAndFix(formData.CashAmount) || 0;
            const CardAmount = parseAndFix(formData.CardAmount) || 0;
            const UPIAmount = parseAndFix(formData.UPIAmount) || 0;

            totalCalculation(
                totals.Quantity,
                totals.Amount,
                totals.DiscountAmount,
                totals.TaxableAmount,
                totals.CGSTAmount,
                totals.SGSTAmount,
                totals.IGSTAmount,
                totals.TotalAmount,
                FreightAmount,
                PackingAmount,
                TCSAmount,
                CashAmount,
                CardAmount,
                UPIAmount
            );

            return updatedItemData;
        });
    };


    const calculateItemData = (item, formData) => {

        // Decide which rate to use
        let baseRate = formData.IsWholeSaleRate
            ? parseAndFix(item.WholeSaleRate)   // <-- Wholesale Rate field
            : parseAndFix(item.SaleRate ?? item.Rate); // <-- Fallback to SaleRate or Rate

        let rate = parseAndFix(baseRate);
        let quantity = parseAndFix(item.Quantity);
        let cgstRate = parseAndFix(item.GSTRate) / 2;
        let sgstRate = parseAndFix(item.GSTRate) / 2;
        
        // Calculate base amount (rate * quantity)
        let amt = (quantity * rate).toFixed(2);
        
        // Calculate discount - prioritize discount amount over percentage
        let totalDiscountAmount = 0;
        let discountAmount = parseAndFix(item.DiscountAmount);
        let discountPercentage = parseAndFix(item.DiscountPercentage);
        
        if (discountAmount > 0) {
            // If discount amount is provided, use it directly
            totalDiscountAmount = discountAmount;
        } else if (discountPercentage > 0) {
            // If only percentage is provided, calculate discount amount from total
            totalDiscountAmount = (parseAndFix(amt) * discountPercentage) / 100;
        }
        
        // Calculate rate after discount for GST calculation
        let discountedRate = rate - (totalDiscountAmount / quantity);
        
        // Calculate sale rate (excluding GST) for GST calculation
        let salerate = (discountedRate / (1 + (cgstRate + sgstRate) / 100)).toFixed(2);
        let taxableAmount = (quantity * salerate).toFixed(2);

        // Calculate GST amounts
        let cgstAmount = 0, sgstAmount = 0, igstAmount = 0;

        if (formData.InvoiceTypeId === 3 || formData.InvoiceTypeId == 4) {
            igstAmount = ((parseAndFix(taxableAmount) * (cgstRate + sgstRate)) / 100).toFixed(2);
        } else {
            cgstAmount = ((parseAndFix(taxableAmount) * cgstRate) / 100).toFixed(2);
            sgstAmount = ((parseAndFix(taxableAmount) * sgstRate) / 100).toFixed(2);
        }

        let defaultFreightGST = Math.max(defaultFreightGSTRate, item.GSTRate);
        let defaultPackingGST = Math.max(defaultPackingGSTRate, item.GSTRate);
        setdefaultFreightGSTRate(defaultFreightGST);
        setdefaultPackingGSTRate(defaultPackingGST);

        const totalAmount = parseAndFix(taxableAmount) + parseAndFix(cgstAmount) + parseAndFix(sgstAmount) + parseAndFix(igstAmount);

        return {
            ...item,
            Amount: amt,
            Rate: rate.toFixed(2),
            DiscountAmount: totalDiscountAmount.toFixed(2),
            TaxableAmount: taxableAmount,
            CGSTAmount: cgstAmount,
            SGSTAmount: sgstAmount,
            IGSTAmount: igstAmount,
            TotalAmount: totalAmount.toFixed(2),

        };
    };

    //handle change
    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        // Immediate update of the input field
        let updatedValue = type === 'checkbox' ? checked : (value === "" ? "0" : value);

        // Validation and adjustment for CardAmount, UPIAmount, and CashAmount
        if (['CardAmount', 'UPIAmount', 'CashAmount'].includes(name)) {
            const grandTotal = parseFloat(formData.GrandTotal || 0);
            const otherAmounts = {
                CardAmount: parseFloat(formData.CashAmount || 0) + parseFloat(formData.UPIAmount || 0),
                UPIAmount: parseFloat(formData.CashAmount || 0) + parseFloat(formData.CardAmount || 0),
                CashAmount: parseFloat(formData.CardAmount || 0) + parseFloat(formData.UPIAmount || 0),
            };

            // Calculate the maximum allowed value for the current field
            const maxAllowed = grandTotal - otherAmounts[name];

            // Ensure the entered value does not exceed the maxAllowed
            updatedValue = Math.min(parseFloat(updatedValue || 0), maxAllowed);
        }

        setFormData((prevData) => ({
            ...prevData,
            [name]: updatedValue,
        }));

        if (['FreightAmount', 'PackingAmount', 'TCSAmount', 'CashAmount', 'CardAmount', 'UPIAmount', 'InvoiceTypeId'].includes(name)) {
            // Use the value directly for the calculation to avoid relying on stale state
            updateFormDataAndDetails(name, updatedValue);
        }
    };

    const updateFormDataAndDetails = (key, value) => {
        // const fixedValue = parseAndFix(value).toFixed(2);
        const fixedValue = parseAndFix(value);

        // Update the formData with the new value
        setFormData((prevData) => ({
            ...prevData,
            [key]: fixedValue,
            ModifiedBy: userId,
        }));

        // Use the updated value for calculations
        const updatedFormData = {
            ...formData,    // current form data
            [key]: fixedValue  // the newly updated value
        };

        // Recalculate invoice details using the latest form data
        const updatedItemData = selectedItems.map((item) => calculateItemData(item, updatedFormData));
        setSelectedItems(updatedItemData);

        // Calculate totals based on the updated invoice details
        const totals = calculateTotals(updatedItemData);

        // Dynamically get the values from the updated form data
        const dynamicValue = (key) => parseAndFix(updatedFormData[key] || 0);

        // Fetch the latest values for calculations               
        const TCSAmount = dynamicValue('TCSAmount');
        const FreightAmount = dynamicValue('FreightAmount');
        const PackingAmount = dynamicValue('PackingAmount');
        let CashAmount = dynamicValue('CashAmount');
        let CardAmount = dynamicValue('CardAmount');
        let UPIAmount = dynamicValue('UPIAmount');
        // Perform the final total calculation
        totalCalculation(
            totals.Quantity,
            totals.Amount,
            totals.DiscountAmount,
            totals.TaxableAmount,
            totals.CGSTAmount,
            totals.SGSTAmount,
            totals.IGSTAmount,
            totals.TotalAmount,
            FreightAmount,
            PackingAmount,
            TCSAmount,
            CashAmount,
            CardAmount,
            UPIAmount,
        );
    };

    // Utility function to calculate totals
    const calculateTotals = (updatedItemData) => {
        return updatedItemData.reduce(
            (acc, item) => {
                acc.Quantity += parseAndFix(item.Quantity);
                acc.Amount += parseAndFix(item.Amount);
                acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                acc.TotalAmount += parseAndFix(item.TotalAmount);
                return acc;
            },
            { Quantity: 0, Amount: 0, TaxableAmount: 0, DiscountAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0, CESSAmount: 0 }
        );
    };

    //Bank
    const [bankOptions, setBankOptions] = useState([]);
    const [selectedBank, setSelectedBank] = useState("");

    const fetchBanks = async () => {
        try {
            const response = await fetchData('PaymentApi', `/Banks/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(method => ({
                    value: method.Id,
                    label: method.Name
                }));
                setBankOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Bank:', error);
        }
    };

    const handleBankChange = (selectedOption) => {
        setSelectedBank(selectedOption);
    };

    useEffect(() => {
        fetchBanks();
    }, []);

    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen((prev) => !prev);
    };

    //handle search [ITEM SEARCH]
    const [isFocused, setIsFocused] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredData = selectedItems.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    const openConfirmDialog = (index) => {
        setItemToDeleteIndex(index);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setItemToDeleteIndex(null);
    };

    // const handleDelete = () => {
    //     if (itemToDeleteIndex !== null) {
    //         const updatedItemList = selectedItems.filter((_, i) => i !== itemToDeleteIndex);
    //         setSelectedItems(updatedItemList);
    //         closeConfirmDialog();
    //     }
    // };

    const handleDelete = () => {
        if (itemToDeleteIndex !== null) {
            const updatedItemList = selectedItems.filter((_, i) => i !== itemToDeleteIndex);
            setSelectedItems(updatedItemList);

            // Recalculate all totals based on updated list
            const totalAmount = updatedItemList.reduce((sum, item) => sum + parseFloat(item.Amount || 0), 0);
            const discountAmount = updatedItemList.reduce((sum, item) => sum + parseFloat(item.DiscountAmount || 0), 0);
            const taxableAmount = updatedItemList.reduce((sum, item) => sum + parseFloat(item.TaxableAmount || 0), 0);
            const cgstAmount = updatedItemList.reduce((sum, item) => sum + parseFloat(item.CGSTAmount || 0), 0);
            const sgstAmount = updatedItemList.reduce((sum, item) => sum + parseFloat(item.SGSTAmount || 0), 0);
            const igstAmount = updatedItemList.reduce((sum, item) => sum + parseFloat(item.IGSTAmount || 0), 0);

            // Grand total = taxable + GST + freight + packing + TCS - discount
            const grandTotal =
                taxableAmount +
                cgstAmount +
                sgstAmount +
                igstAmount +
                parseFloat(formData.FreightAmount || 0) +
                parseFloat(formData.PackingAmount || 0) +
                parseFloat(formData.TCSAmount || 0);

            const roundOff = Math.round(grandTotal) - grandTotal;

            setFormData((prev) => ({
                ...prev,
                TotalAmount: totalAmount.toFixed(2),
                DiscountAmount: discountAmount.toFixed(2),
                TaxableAmount: taxableAmount.toFixed(2),
                CGSTAmount: cgstAmount.toFixed(2),
                SGSTAmount: sgstAmount.toFixed(2),
                IGSTAmount: igstAmount.toFixed(2),
                RoundOff: roundOff.toFixed(2),
                GrandTotal: (grandTotal + roundOff).toFixed(2),
                BalanceAmount: (
                    grandTotal +
                    roundOff -
                    (parseFloat(prev.CashAmount || 0) +
                        parseFloat(prev.CardAmount || 0) +
                        parseFloat(prev.UPIAmount || 0))
                ).toFixed(2),
            }));

            closeConfirmDialog();
        }
    };


    // Handle Submit
    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        // Validate CustomerName
        if (!formData.CustomerName) {
            setErrorMessage('Customer is required!');
            setIsLoading(false);
            return;
        }

        // Validate BankId if UPIAmount or CardAmount is present
        if ((formData.UPIAmount > 0 || formData.CardAmount > 0) && !selectedBank) {
            setErrorMessage('Bank selection is mandatory for UPI or Card payments!');
            setIsLoading(false);
            return;
        }
        // Validation: If MasterId is 0 or null, BalanceAmount > 0 is not allowed
        if ((formData.MasterId === 0 || formData.MasterId === null || formData.MasterId === '' || formData.MasterId === undefined) && parseFloat(formData.BalanceAmount) > 0) {
            setErrorMessage('Credit is not allowed for walkin customer!');
            setIsLoading(false);
            return;
        }

        // Validate State For InvoiceTypeId=4
        if ((formData.InvoiceTypeId == 4) && !selectedStateCode) {
            setErrorMessage('State selection is mandatory for IGST Customer!');
            setIsLoading(false);
            return;
        }

        // model for balanced amount 

        const cash = parseFloat(formData.CashAmount || 0);
        const grandTotal = parseFloat(formData.GrandTotal || 0);

        if (cash > 0 && !showModal) {
            // Open modal only for cash
            setCollectedAmount(cash);
            setBalanceAmount(cash - grandTotal);
            //setPendingSubmitData({ formData, selectedItems });
            setShowModal(true);
            setIsLoading(false);
            return; // stop here until modal confirmed
        }

        // Prepare formData
        // Validate at least one item is selected
        if (!selectedItems || selectedItems.length === 0) {
            setErrorMessage('At least one item must be selected to continue!');
            setIsLoading(false);
            return;
        }

        const updatedFormData = {
            ...formData,
            CreatedBy: userId,
            BranchId: branchId,
            CompanyId: companyId,
            BankId: selectedBank ? selectedBank.value : null, // Save BankId
            StateId: selectedStateCode ? selectedStateCode : null, // Save StateId
        };

        // Create data object to send to the API
        const CreateData = {
            Proforma: updatedFormData,
            ProformaDetails: selectedItems,
        };

        // Post data to API
        postData('ProformaApi', CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                const SaleId = response.kotId;
                handlePrint(SaleId); // Handle print with SaleId
                history.push('/ProformaIndex'); // Redirect to SaleIndex
            })
            .catch((error) => {
                console.error('Error updating record:', error);
                setErrorMessage('Error updating record. Please try again.');
            })
            .finally(() => {
                setIsLoading(false);
            });
    };


    const handlePrint = async (SALEID) => {
        try {
            // ------------------ FETCH DATA ------------------
            const response = await fetchData('ProformaApi', `/ProformaPrint/${SALEID}`, token);
            const labelData = response.response_data;

            if (!labelData?.ProformaPrint || !labelData?.ProformaPrintItems) {
                throw new Error("Invalid invoice data.");
            }

            const header = labelData.ProformaPrint;
            const items = labelData.ProformaPrintItems;

            // ------------------ INITIALIZE PDF ------------------
            const doc = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: [80, 280] // POS roll size
            });

            const margin = { top: 5, left: 0.8, right: 0.8 };
            const pageWidth = doc.internal.pageSize.getWidth();
            const usableWidth = pageWidth - margin.left - margin.right;
            let y = margin.top;

            const yStartOuter = margin.top - 1;

            // ------------------ HEADER ------------------
            y += 2;
            doc.setFontSize(8);
            doc.setFont('helvetica', 'normal');
            doc.text(`GSTIN : ${header.CompanyGSTNumber || ''}`, margin.left + 1, y);
            doc.text(`Ph : ${header.CompanyContactNumber1 || ''}`, pageWidth - margin.right - 1, y, { align: 'right' });
            y += 6;

            doc.setFontSize(12);
            doc.setFont('helvetica', 'bold');
            doc.text(header.CompanyName || '', pageWidth / 2, y, { align: 'center' });
            y += 6;

            doc.setFont('helvetica', 'normal');
            doc.setFontSize(8);
            const addrLines = doc.splitTextToSize(header.CompanyAddressLine || '', usableWidth);
            addrLines.forEach(line => {
                doc.text(line, pageWidth / 2, y, { align: 'center' });
                y += 3;
            });

            doc.setLineWidth(0.1);
            doc.line(margin.left, y, pageWidth - margin.right, y);
            y += 3;

            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8);
            doc.text("Bill of Supply", pageWidth / 2, y, { align: 'center' });
            y += 3;

            // ------------------ BILL INFO + CUSTOMER ------------------
            const boxYStart = y;
            y += 3;

            doc.setFont('helvetica', 'normal');
            doc.setFontSize(8);

            const invNo = header.InvoiceNo || [header.BillNumber, header.FinYear].filter(Boolean).join('/');
            const billDate = header.BillDate ? new Date(header.BillDate).toLocaleDateString('en-GB') : '';
            const billTime = header.BillTime;

            doc.text(`Bill No: ${invNo}`, margin.left + 1, y);
            doc.text(`Date: ${billDate}`, pageWidth - margin.right - 1, y, { align: 'right' });
            y += 3;
            doc.text(`Time: ${billTime}`, pageWidth - margin.right - 1, y, { align: 'right' });
            y += 4;

            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8);
            doc.text("Customer Details:", margin.left + 1, y);
            y += 3;

            doc.setFont('helvetica', 'normal');
            doc.setFontSize(8);
            doc.text(`Name: ${header.CustomerName || ''}`, margin.left + 1, y);
            y += 3;

            if (header.CustomerAddress) {
                doc.text(`Address: ${header.CustomerAddress}`, margin.left + 1, y);
                y += 3;
            }

            if (header.CustomerContactNumber) {
                doc.text(`Contact: ${header.CustomerContactNumber}`, margin.left + 1, y);
                y += 3;
            }

            const boxYEnd = y + 1;
            doc.setLineWidth(0.1);
            doc.rect(0.8, boxYStart - 1, pageWidth - 1.6, boxYEnd - boxYStart + 1);
            y = boxYEnd;

            // ------------------ ITEMS TABLE ------------------
            const filteredItems = items.filter(i => (i.Quantity ?? 0) > 0);
            const rows = filteredItems.map((i, idx) => [
                idx + 1,
                i.ItemName || "",
                (i.Quantity ?? 0).toString(),
                (i.Rate ?? 0).toFixed(2),
                (i.DiscountAmount ?? 0).toFixed(2),
                (i.TotalAmount ?? 0).toFixed(2),
            ]);


            autoTable(doc, {
                startY: y,
                margin: { left: margin.left, right: margin.right },
                head: [["Sr", "Product", "Qty", "Rate", "Disc", "Amount"]],
                body: rows,
                theme: "grid",
                styles: {
                    fontSize: 8,
                    cellPadding: 1,
                    lineColor: [0, 0, 0],
                    lineWidth: 0.1,
                    textColor: [0, 0, 0],
                    fontStyle: "bold", // ? bold for all item rows
                },
                headStyles: {
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    lineColor: [0, 0, 0],
                    lineWidth: 0.1,
                    fontStyle: "bold", // ? bold for header too
                },
                columnStyles: {
                    0: { halign: 'left' },
                    1: { halign: 'left' },
                    2: { halign: 'right' },
                    3: { halign: 'right' },
                    4: { halign: 'right' },
                    5: { halign: 'right' },
                },
            });


            y = doc.lastAutoTable.finalY + 6;

            // ------------------ TOTALS (Right Side Aligned, Left Labels) ------------------
            const leftX = margin.left + 45;
            const rightX = pageWidth - margin.right - 1.5;

            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8);

            // Taxable Amount
            doc.text(`Taxable Amt`, leftX, y);
            doc.text(`${(Number(header.TaxableAmount) || 0).toFixed(2)}`, rightX, y, { align: 'right' });
            y += 4;

            // CGST Amount
            doc.text(`CGST Amt`, leftX, y);
            doc.text(`${(Number(header.CGSTAmount) || 0).toFixed(2)}`, rightX, y, { align: 'right' });
            y += 4;

            // SGST Amount
            doc.text(`SGST Amt`, leftX, y);
            doc.text(`${(Number(header.SGSTAmount) || 0).toFixed(2)}`, rightX, y, { align: 'right' });
            y += 4;

            // Round Off
            doc.text(`Round Off`, leftX, y);
            doc.text(`${(Number(header.RoundOff) || 0).toFixed(2)}`, rightX, y, { align: 'right' });
            y += 4;

            // Total Amount (bold)
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8);
            doc.text(`Total Amt`, leftX, y);
            doc.text(`${(Number(header.GrandTotal) || 0).toFixed(2)}`, rightX, y, { align: 'right' });
            y += 4;
            doc.setFont('helvetica', 'normal'); // reset font

            // ------------------ AMOUNT IN WORDS ------------------
            doc.setLineWidth(0.1);
            doc.line(margin.left, y, pageWidth - margin.right, y);
            y += 3;

            const grandTotal = Number(header.GrandTotal) || 0;
            const numberToWords = (num) => {
                const a = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
                const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
                const inWords = (n) => {
                    if (n < 20) return a[n];
                    if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? ' ' + a[n % 10] : '');
                    if (n < 1000) return a[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' and ' + inWords(n % 100) : '');
                    if (n < 100000) return inWords(Math.floor(n / 1000)) + ' Thousand' + (n % 1000 ? ' ' + inWords(n % 1000) : '');
                    if (n < 10000000) return inWords(Math.floor(n / 100000)) + ' Lakh' + (n % 100000 ? ' ' + inWords(n % 100000) : '');
                    return inWords(Math.floor(n / 10000000)) + ' Crore' + (n % 10000000 ? ' ' + inWords(n % 10000000) : '');
                };
                const parts = num.toFixed(2).split('.');
                let words = inWords(Number(parts[0])) + ' Rupees';
                if (Number(parts[1]) > 0) words += ' and ' + inWords(Number(parts[1])) + ' Paise';
                return words + ' Only';
            };

            doc.setFont('helvetica', 'bold');
            doc.setFontSize(7);
            doc.text(`${numberToWords(grandTotal)}`, margin.left + 1, y);
            y += 2;

            // ------------------ TERMS & CONDITIONS ------------------
            doc.setLineWidth(0.1);
            doc.line(margin.left, y, pageWidth - margin.right, y);
            y += 3;

            doc.setFont('helvetica', 'bold');
            doc.text(" ", margin.left + 1, y);
            y += 2;

            // ------------------ QR + Tax Breakdown (side by side) ------------------
            const qrBoxWidth = pageWidth * 0.3; // ~30% width for QR
            const qrBoxHeight = 25;
            const tableStartX = qrBoxWidth + 5; // leave small gap between QR and table
            let sectionY = y;

            // --- QR ---
            try {
                doc.addImage(
                    Logo, "PNG",
                    margin.left + 1,
                    sectionY,
                    qrBoxWidth, qrBoxHeight
                );
            } catch (error) {
                console.warn("QR image missing", error);
                doc.setFontSize(6);
                doc.text("QR IMAGE MISSING", margin.left + 1 + qrBoxWidth / 2, sectionY + qrBoxHeight / 2, { align: 'center' });
            }

            // --- Tax Breakdown Table ---
            const filteredItem = items.filter(i => (i.Quantity ?? 0) > 0);
            const taxGroups = {};
            filteredItem.forEach(item => {
                const gst = item.GSTRate ?? 0;
                if (!taxGroups[gst]) taxGroups[gst] = { amount: 0, cgst: 0, sgst: 0 };
                taxGroups[gst].amount += item.TaxableAmount ?? 0;
                taxGroups[gst].cgst += item.CGSTAmount ?? 0;
                taxGroups[gst].sgst += item.SGSTAmount ?? 0;
            });

            const taxBreakdownRows = Object.entries(taxGroups).map(([percent, vals]) => ([
                percent,
                vals.amount.toFixed(2),
                vals.cgst.toFixed(2),
                vals.sgst.toFixed(2)
            ]));

            const totalRow = taxBreakdownRows.reduce((acc, row) => {
                for (let i = 1; i <= 3; i++) acc[i] += parseFloat(row[i]);
                return acc;
            }, ['Total', 0, 0, 0]).map((v, i) => i === 0 ? v : v.toFixed(2));

            taxBreakdownRows.push(totalRow);

            // Table layout
            const colWidths = [8, 13, 13, 13];
            const colTitles = ['%', 'Amount', 'CGST', 'SGST'];

            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8);
            doc.text('Tax Breakdown', tableStartX, sectionY);

            let tableY = sectionY + 2;

            // Header
            let colX = tableStartX;
            colTitles.forEach((title, i) => {
                doc.rect(colX, tableY, colWidths[i], 5);
                doc.text(title, colX + colWidths[i] / 2, tableY + 3.2, { align: 'center' });
                colX += colWidths[i];
            });

            // Body
            doc.setFont('helvetica', 'normal');
            let currentY = tableY + 5;
            taxBreakdownRows.forEach(row => {
                let rowX = tableStartX;
                row.forEach((cell, i) => {
                    doc.rect(rowX, currentY, colWidths[i], 5);
                    doc.text(cell.toString(), rowX + colWidths[i] / 2, currentY + 3.2, { align: 'center' });
                    rowX += colWidths[i];
                });
                currentY += 5;
            });

            // Update y for next section
            y = Math.max(sectionY + qrBoxHeight, currentY) + 6;


            // ------------------ FOOTER ------------------
            doc.setFontSize(8);
            doc.setFont('helvetica', 'bold');
            doc.text("THANK YOU - VISIT AGAIN", pageWidth / 2, y, { align: 'center' });

            const yEndOuter = y + 2;
            doc.setLineWidth(0.1);
            doc.rect(0.5, yStartOuter, pageWidth - 1, yEndOuter - yStartOuter);

            // ------------------ PRINT ------------------
            const blob = doc.output('blob');
            const blobUrl = URL.createObjectURL(blob);
            const win = window.open(blobUrl, '_blank');
            if (win) win.onload = () => {
                win.focus();
                win.print();
            };

        } catch (err) {
            console.error("Error generating invoice:", err);
        }
    };

    return (
        <div style={{ fontFamily: "Segoe UI, sans-serif", fontSize: "12px", width: "100%", padding: "6px", boxSizing: "border-box", backgroundColor: "#f5f5f5" }}>

            {/* -- Color tokens & shared styles -- */}
            {(() => { return null; })()}

            {/* -- Top action bar -- */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px", gap: "8px" }}>
                <span style={{ fontWeight: 700, fontSize: "13px", color: "#1a7a4a" }}>Proforma Create</span>
                <div style={{ display: "flex", gap: "8px" }}>
                    <button onClick={handleSubmit} disabled={isLoading}
                        style={{ height: "30px", padding: "0 18px", borderRadius: "4px", border: "none", backgroundColor: "#1a7a4a", color: "#fff", fontWeight: 700, fontSize: "12px", cursor: "pointer", display: "flex", alignItems: "center", gap: "4px" }}>
                        {isLoading ? <CircularProgress size={13} color="inherit" /> : null} Save
                    </button>
                    <Link to="/ProformaIndex" onClick={() => localStorage.setItem("shouldReload", "true")}
                        style={{ height: "30px", padding: "0 14px", borderRadius: "4px", border: "1px solid #d1d5db", backgroundColor: "#fff", color: "#374151", fontWeight: 600, fontSize: "12px", cursor: "pointer", display: "flex", alignItems: "center", textDecoration: "none" }}>
                        Back
                    </Link>
                </div>
            </div>

            {/* -- Error messages -- */}
            {errorMessage && (
                <div style={{ marginBottom: "6px", padding: "6px 12px", backgroundColor: "#fef2f2", border: "1px solid #fecaca", borderRadius: "4px", fontSize: "11px", color: "#ef4444" }}>
                    {errorMessage}
                </div>
            )}
            {errorMessageModel && (
                <div style={{ marginBottom: "6px", padding: "6px 12px", backgroundColor: "#fef2f2", border: "1px solid #fecaca", borderRadius: "4px", fontSize: "11px", color: "#ef4444" }}>
                    {errorMessageModel}
                </div>
            )}

            {/* -- Bill details card -- */}
            {(() => {
                // -- Color tokens --
                const GN  = "#1a7a4a";
                const GNL = "#e8f5ee";
                const GND = "#155d38";
                // -- Shared input styles --
                const inp2  = { border: "1px solid #d1d5db", borderRadius: "4px", fontSize: "12px", height: "30px", width: "100%", padding: "0 8px", outline: "none", backgroundColor: "#fff", boxSizing: "border-box", color: "#1a2e2e" };
                const inp2R = { ...inp2, textAlign: "right" };
                const lbl2  = { fontSize: "10px", color: "#6b7280", display: "block", marginBottom: "2px", fontWeight: 500 };
                const ss2 = {
                    control: (b) => ({ ...b, minHeight: "30px", height: "30px", fontSize: "12px", borderColor: "#d1d5db", borderRadius: "4px", boxShadow: "none" }),
                    valueContainer: (b) => ({ ...b, height: "30px", padding: "0 8px" }),
                    indicatorsContainer: (b) => ({ ...b, height: "30px" }),
                    menuPortal: (b) => ({ ...b, zIndex: 3000 }),
                    menu: (b) => ({ ...b, fontSize: "12px" }),
                };
                // -- Section styles --
                const sectionBox  = { backgroundColor: "#fff", border: "1px solid #e5e7eb", borderRadius: "6px", marginBottom: "8px", overflow: "hidden" };
                const sectionHead = { backgroundColor: GNL, borderBottom: `2px solid ${GN}`, padding: "5px 12px" };
                const sectionTitle = { fontSize: "11px", fontWeight: 700, color: GND, textTransform: "uppercase", letterSpacing: "0.5px" };
                // -- Alias for items table --
                const inp  = inp2;
                const inpR = inp2R;
                return (
                    <>
                        {/* -- SECTION 1 � Sale Information -- */}
                        <div style={sectionBox}>
                            <div style={sectionHead}><span style={sectionTitle}>Sale Information</span></div>
                            <div style={{ padding: "8px 12px", display: "flex", gap: "10px", alignItems: "flex-end", flexWrap: "wrap" }}>
                                {/* Bill No */}
                                <div style={{ flex: "0 0 110px" }}>
                                    <label style={lbl2}>Bill No</label>
                                    <input type="text" name="BillNumber" value={`${formData.BillNumber || ""}/${formData.FinYear || ""}`} onChange={handleChange} style={inp2} />
                                </div>
                                {/* Bill Date */}
                                <div style={{ flex: "0 0 130px" }}>
                                    <label style={lbl2}>Bill Date</label>
                                    <input type="date" name="BillDate" value={formatDateForInput(formData.BillDate)} onChange={handleChange} style={inp2} />
                                </div>
                                {/* Customer */}
                                <div style={{ flex: "1 1 200px" }}>
                                    <label style={lbl2}>Customer</label>
                                    <AsyncCreatableSelect
                                        cacheOptions
                                        loadOptions={fetchOptions}
                                        onInputChange={handleInputChange}
                                        onChange={handleCustomerSelect}
                                        value={selectedOption}
                                        placeholder="Type or select a customer"
                                        formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
                                        isClearable
                                        onCreateOption={(inputValue) => {
                                            const newOption = { value: inputValue, label: inputValue };
                                            setSupplierOptions([...supplierOptions, newOption]);
                                            setSelectedOption(newOption);
                                            setFormData((prevData) => ({
                                                ...prevData,
                                                MasterId: 0,
                                                CreatedBy: userId,
                                                CustomerName: inputValue,
                                                CustomerAddress: "",
                                                GSTNumber: "",
                                                ContactNumber: "",
                                                InvoiceTypeId: 2,
                                                InvoiceTypeName: "B To C",
                                                CustomerLedgerAmount: 0,
                                            }));
                                            setSelectedInvoiceType({ value: 2, label: "B To C" });
                                            fetchmaxbillno(2);
                                        }}
                                        isSearchable
                                        menuPortalTarget={document.body}
                                        styles={ss2}
                                    />
                                </div>
                                {/* Ph.No */}
                                <div style={{ flex: "0 0 120px" }}>
                                    <label style={lbl2}>Ph.No</label>
                                    <input type="text" name="ContactNumber" value={formData.ContactNumber || ""} onChange={handleChange} style={inp2} />
                                </div>
                                {/* Wholesale checkbox */}
                                
                                {/* GST No */}
                                <div style={{ flex: "0 0 130px" }}>
                                    <label style={lbl2}>GST No</label>
                                    <input type="text" name="GSTNumber" value={formData.GSTNumber || ""} onChange={handleChange} style={inp2} />
                                </div>
                                {/* Invoice Type */}
                                <div style={{ flex: "0 0 140px" }}>
                                    <label style={lbl2}>Invoice Type</label>
                                    <Select
                                        options={dropdownInvoiceTypeOptions.filter((cat) => ["2", "4"].includes(cat.Id.toString())).map((cat) => ({ value: cat.Id, label: cat.Name }))}
                                        value={selectedInvoiceType ? { value: selectedInvoiceType.value, label: selectedInvoiceType.label } : null}
                                        onChange={(selected) => {
                                            setSelectedInvoiceType(selected);
                                            setFormData((prev) => ({ ...prev, InvoiceTypeId: selected.value }));
                                            handleChange({ target: { name: "InvoiceTypeId", value: selected.value, type: "text" } });
                                            fetchmaxbillno(selected.value);
                                        }}
                                        isSearchable placeholder="Invoice Type" menuPortalTarget={document.body} styles={ss2}
                                        isDisabled={formData.MasterId !== null && formData.MasterId !== 0}
                                    />
                                </div>
                                {/* Salesman */}
                                <div style={{ flex: "0 0 140px" }}>
                                    <label style={lbl2}>Salesman</label>
                                    <Select
                                        options={dropdownSalesManOptions.map((item) => ({ value: item.Id, label: item.Name }))}
                                        value={selectedSalesMan ? { value: selectedSalesMan, label: dropdownSalesManOptions.find((s) => s.Id === selectedSalesMan)?.Name } : null}
                                        onChange={(selected) => { setSelectedSalesMan(selected.value); setFormData((prev) => ({ ...prev, SalesManId: selected.value })); }}
                                        isSearchable placeholder="Salesman" menuPortalTarget={document.body} styles={ss2}
                                    />
                                </div>
                                <div style={{ display: "flex", alignItems: "center", gap: "5px", paddingBottom: "4px" }}>
                                    <input id="IsWholeSaleRate" type="checkbox" name="IsWholeSaleRate" checked={formData.IsWholeSaleRate || false} onChange={handleModalInputChange}
                                        style={{ width: "14px", height: "14px", accentColor: GN, cursor: "pointer" }} />
                                    <label htmlFor="IsWholeSaleRate" style={{ fontSize: "10px", fontWeight: 700, color: GN, cursor: "pointer", whiteSpace: "nowrap" }}>Whole Sale</label>
                                </div>
                                
                                {/* State (only if InvoiceTypeId===4) */}
                                {formData.InvoiceTypeId === 4 && (
                                    <div style={{ flex: "0 0 150px" }}>
                                        <label style={lbl2}>State</label>
                                        <Select
                                            options={dropdownStateCodeOptions.map((item) => ({ value: item.Id, label: `${item.Code} - ${item.Name}` }))}
                                            value={selectedStateCode ? { value: selectedStateCode, label: (dropdownStateCodeOptions.find((s) => s.Id === selectedStateCode)?.Code || "") + " - " + (dropdownStateCodeOptions.find((s) => s.Id === selectedStateCode)?.Name || "") } : null}
                                            onChange={(selected) => { setSelectedStateCode(selected.value); setFormData((prev) => ({ ...prev, StateId: selected.value })); }}
                                            isSearchable placeholder="State" menuPortalTarget={document.body} styles={ss2}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* -- SECTION 2 � Sale Items -- */}
                        <div style={sectionBox}>
                            <div style={{ ...sectionHead, display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "6px" }}>
                                <span style={sectionTitle}>Sale Items * ({filteredData.length} items)</span>
                                {/* Inline add row */}
                                <div style={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "nowrap" }}>
                                    <div style={{ width: "320px" }}>
                                        <AsyncSelect
                                            cacheOptions loadOptions={fetchItemOptions} value={selectedItemOption} onChange={handleChangeDrop}
                                            placeholder="Search item" isSearchable menuPortalTarget={document.body}
                                            styles={{
                                                control: (b) => ({ ...b, minHeight: "26px", height: "26px", fontSize: "12px", borderColor: GN, borderRadius: "4px", boxShadow: "none" }),
                                                valueContainer: (b) => ({ ...b, height: "26px", padding: "0 6px" }),
                                                indicatorsContainer: (b) => ({ ...b, height: "26px" }),
                                                menuPortal: (b) => ({ ...b, zIndex: 3000 }),
                                                menu: (b) => ({ ...b, fontSize: "12px" }),
                                            }}
                                        />
                                    </div>
                                    <input type="number" name="Quantity" value={modalData.Quantity} max={modalData.BalanceStock}
                                        onChange={(e) => { const v = e.target.value === "" ? "" : parseFloat(e.target.value, 10); if (v === "" || v <= modalData.BalanceStock) handleModalInputChange(e); }}
                                        placeholder="Qty" style={{ ...inp2R, width: "60px", height: "26px" }} />
                                    <input type="number" name="Rate" value={modalData.Rate} onChange={handleModalInputChange}
                                        placeholder="Rate" style={{ ...inp2R, width: "80px", height: "26px" }} />
                                    {modalData.BalanceStock > 0 && (
                                        <span style={{ fontSize: "10px", backgroundColor: GNL, color: GND, padding: "2px 6px", borderRadius: "10px", fontWeight: 600, whiteSpace: "nowrap", border: `1px solid ${GN}` }}>
                                            Stock: {modalData.BalanceStock}
                                        </span>
                                    )}
                                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                        <input id="IsWholeSaleRateModal" type="checkbox" name="IsWholeSaleRate" checked={formData.IsWholeSaleRate || false} onChange={handleModalInputChange}
                                            style={{ width: "13px", height: "13px", accentColor: GN, cursor: "pointer" }} />
                                        <label htmlFor="IsWholeSaleRateModal" style={{ fontSize: "10px", fontWeight: 600, color: GN, cursor: "pointer", whiteSpace: "nowrap" }}>Whole Sale</label>
                                    </div>
                                    <button onClick={saveModalData}
                                        style={{ height: "26px", padding: "0 14px", borderRadius: "4px", border: "none", backgroundColor: GN, color: "#fff", fontWeight: 700, fontSize: "11px", cursor: "pointer", whiteSpace: "nowrap" }}>
                                        + Add
                                    </button>
                                </div>
                            </div>
                            {/* Items table */}
                            <div style={{ maxHeight: "280px", overflowY: "auto" }}>
                                {filteredData.length === 0 ? (
                                    <div style={{ backgroundColor: GNL, padding: "20px", textAlign: "center", fontSize: "12px", color: GND }}>No items added</div>
                                ) : (
                                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
                                        <thead style={{ backgroundColor: GN, color: "#fff", position: "sticky", top: 0 }}>
                                            <tr>
                                                {["Sl No", "Item", "Qty", "Rate", "Disc%", "Disc Amt", "GST%", "GST Amt", "Taxable", "Total"].map((h, i) => (
                                                    <th key={i} style={{ padding: "6px 4px", textAlign: i > 1 ? "right" : "left", fontSize: "10px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.4px", whiteSpace: "nowrap" }}>{h}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredData.map((item, index) => (
                                                <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#fff" : GNL, borderBottom: "1px solid #e5e7eb" }}
                                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = GNL}
                                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? "#fff" : GNL}>
                                                    <td style={{ padding: "3px 6px", textAlign: "center", whiteSpace: "nowrap" }}>
                                                        {index + 1}
                                                        <DeleteIcon style={{ color: "#dc2626", cursor: "pointer", marginLeft: "4px", fontSize: "14px", verticalAlign: "middle" }} onClick={() => openConfirmDialog(index)} />
                                                    </td>
                                                    <td style={{ padding: "3px 4px", minWidth: "160px", fontWeight: 600 }}>{item.ItemName}</td>
                                                    <td style={{ padding: "2px", width: "70px" }}><input type="number" value={item.Quantity} name="Quantity" onChange={(e) => handleCalculation(e, index, "Quantity")} style={{ ...inpR, height: "24px", borderRadius: "4px" }} /></td>
                                                    <td style={{ padding: "2px", width: "100px" }}><input type="number" value={item.Rate || 0} name="Rate" onChange={(e) => handleCalculation(e, index, "Rate")} style={{ ...inpR, height: "24px", borderRadius: "4px" }} /></td>
                                                    <td style={{ padding: "2px", width: "80px" }}><input type="number" value={item.DiscountPercentage || 0} name="DiscountPercentage" onChange={(e) => handleCalculation(e, index, "DiscountPercentage")} style={{ ...inpR, height: "24px", borderRadius: "4px" }} /></td>
                                                    <td style={{ padding: "2px", width: "90px" }}><input type="number" inputMode="decimal" step="any" name="DiscountAmount" value={item.DiscountAmount ?? ""} onChange={(e) => handleCalculation(e, index, "DiscountAmount")} onBlur={(e) => handleDiscountAmountBlur(e, index)} style={{ ...inpR, height: "24px", borderRadius: "4px" }} /></td>
                                                    <td style={{ padding: "3px 4px", textAlign: "right", whiteSpace: "nowrap", fontSize: "11px", color: "#6b7280" }}>{item.GSTRate ? parseFloat(item.GSTRate) : 0}%</td>
                                                    <td style={{ padding: "2px", width: "90px" }}><input value={(parseFloat(item.CGSTAmount || 0) + parseFloat(item.SGSTAmount || 0) + parseFloat(item.IGSTAmount || 0)).toFixed(2)} readOnly style={{ ...inpR, height: "24px", borderRadius: "4px" }} /></td>
                                                    <td style={{ padding: "2px", width: "100px" }}><input value={item.TaxableAmount || 0} readOnly style={{ ...inpR, height: "24px", borderRadius: "4px" }} /></td>
                                                    <td style={{ padding: "2px", width: "100px" }}><input value={item.TotalAmount || 0} readOnly style={{ ...inpR, height: "24px", borderRadius: "4px", fontWeight: 700, color: GND }} /></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>

                        {/* -- Delete confirm modal -- */}
                        <Modal open={confirmDialogOpen} onClose={closeConfirmDialog} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <div style={{ padding: "20px 24px", backgroundColor: "#fff", borderRadius: "12px", minWidth: "300px", boxShadow: "0 8px 32px rgba(0,0,0,0.12)", textAlign: "center" }}>
                                <div style={{ fontSize: "13px", fontWeight: 700, color: "#1a2e2e", marginBottom: "8px" }}>Delete Item?</div>
                                <p style={{ fontSize: "12px", color: "#5a7a7a", marginBottom: "16px" }}>Are you sure you want to remove this item?</p>
                                <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
                                    <button onClick={handleDelete} style={{ padding: "6px 16px", borderRadius: "7px", border: "none", backgroundColor: "#ef4444", color: "#fff", fontWeight: 700, fontSize: "11px", cursor: "pointer" }}>Delete</button>
                                    <button onClick={closeConfirmDialog} style={{ padding: "6px 16px", borderRadius: "7px", border: "1px solid rgba(0,0,0,0.12)", backgroundColor: "#fff", color: "#5a7a7a", fontWeight: 600, fontSize: "11px", cursor: "pointer" }}>Cancel</button>
                                </div>
                            </div>
                        </Modal>

                        {/* -- SECTION 3 � Bottom: Additional Charges + Summary -- */}
                        <div style={{ display: "flex", gap: "10px", alignItems: "flex-start" }}>
                            {/* Left: Additional Charges */}
                            <div style={{ ...sectionBox, flex: "1 1 0", marginBottom: 0 }}>
                                <div style={sectionHead}><span style={sectionTitle}>Additional Charges</span></div>
                                <div style={{ padding: "10px 12px" }}>
                                    {/* Row 1: Freight, Packing, TCS, Cash, UPI, Card, Credit Amount */}
                                    <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                                        <div style={{ flex: "1 1 0" }}>
                                            <label style={lbl2}>Freight <span style={{ color: "#6b7280" }}>({formData.FreightGSTRate}% GST: {formData.FreightGSTAmount})</span></label>
                                            <input type="number" name="FreightAmount" value={formData.FreightAmount || ""} onChange={handleChange} style={inp2R} />
                                        </div>
                                        <div style={{ flex: "1 1 0" }}>
                                            <label style={lbl2}>Packing <span style={{ color: "#6b7280" }}>({formData.PackingGSTRate}% GST: {formData.PackingGSTAmount})</span></label>
                                            <input type="number" name="PackingAmount" value={formData.PackingAmount || ""} onChange={handleChange} style={inp2R} />
                                        </div>
                                        <div style={{ flex: "1 1 0" }}>
                                            <label style={lbl2}>TCS Amount</label>
                                            <input type="number" name="TCSAmount" value={formData.TCSAmount || ""} onChange={handleChange} style={inp2R} />
                                        </div>
                                        <div style={{ flex: "1 1 0" }}>
                                            <label style={lbl2}>Cash Amount</label>
                                            <input type="number" name="CashAmount" value={formData.CashAmount || ""} onChange={handleChange} min="0" style={{ ...inp2R, fontWeight: 700, color: "#059669" }} />
                                        </div>
                                        <div style={{ flex: "1 1 0" }}>
                                            <label style={lbl2}>UPI Amount</label>
                                            <input type="number" name="UPIAmount" value={formData.UPIAmount || ""} onChange={handleChange} min="0" style={{ ...inp2R, fontWeight: 700, color: "#059669" }} />
                                        </div>
                                        <div style={{ flex: "1 1 0" }}>
                                            <label style={lbl2}>Card Amount</label>
                                            <input type="number" name="CardAmount" value={formData.CardAmount || ""} onChange={handleChange} min="0" style={{ ...inp2R, fontWeight: 700, color: "#059669" }} />
                                        </div>
                                        <div style={{ flex: "1 1 0" }}>
                                            <label style={lbl2}>Credit Amount</label>
                                            <input type="text" name="BalanceAmount" value={formData.BalanceAmount || ""} readOnly
                                                style={{ ...inp2R, fontWeight: 700, color: parseFloat(formData.BalanceAmount) > 0 ? "#ef4444" : "#1a2e2e", backgroundColor: parseFloat(formData.BalanceAmount) > 0 ? "#fef2f2" : "#f8fafa" }} />
                                        </div>
                                    </div>
                                    {/* Row 2: Remarks, Bank */}
                                    <div style={{ display: "flex", gap: "8px", alignItems: "flex-end" }}>
                                        <div style={{ flex: "5 1 0" }}>
                                            <label style={lbl2}>Remarks</label>
                                            <input type="text" name="Remarks" value={formData.Remarks || ""} onChange={handleChange} style={inp2} />
                                        </div>
                                        <div style={{ flex: "1 1 0" }}>
                                            <label style={lbl2}>Bank</label>
                                            <Select options={bankOptions} value={selectedBank || null} onChange={handleBankChange} isSearchable placeholder="Bank" menuPortalTarget={document.body} styles={ss2} />
                                        </div>                                       
                                    </div>
                                    <p style={{ fontSize: "10px", color: "#9ca3af", fontStyle: "italic", margin: "4px 0 0 0" }}>Bank field appears for UPI/Card payments</p>
                                </div>
                            </div>
                            {/* Right: Summary */}
                            <div style={{ ...sectionBox, width: "200px", flexShrink: 0, marginBottom: 0 }}>
                                <div style={sectionHead}><span style={sectionTitle}>Summary</span></div>
                                <div style={{ padding: "8px 12px" }}>
                                    {[
                                        ["Subtotal", formData.TotalAmount, false],
                                        ["Discount", formData.DiscountAmount, true],
                                        ["Taxable", formData.TaxableAmount, false],
                                        ["CGST", formData.CGSTAmount, false],
                                        ["SGST", formData.SGSTAmount, false],
                                        ["IGST", formData.IGSTAmount, false],
                                        ["TCS", formData.TCSAmount, false],
                                        ["Round Off", formData.RoundOff, false],
                                    ].map(([label, val, isDiscount]) => (
                                        <div key={label} style={{ display: "flex", justifyContent: "space-between", padding: "3px 0", borderBottom: "1px solid #f3f4f6", fontSize: "11px" }}>
                                            <span style={{ color: "#6b7280" }}>{label}</span>
                                            <span style={{ color: isDiscount ? "#ef4444" : "#1a2e2e", fontWeight: 700, fontSize: "12px" }}>{isDiscount ? "- " : ""}{parseFloat(val || 0).toFixed(2)}</span>
                                        </div>
                                    ))}
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "5px 0 2px 0", borderTop: `2px solid ${GN}`, marginTop: "2px" }}>
                                        <span style={{ fontSize: "12px", fontWeight: 700, color: GND }}>Total</span>
                                        <span style={{ fontSize: "13px", fontWeight: 700, color: GN }}>{parseFloat(formData.GrandTotal || 0).toFixed(2)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                );
            })()}

            {/* -- Cash collection modal -- */}
            {showModal && (
                <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}>
                    <div style={{ background: "#ffffff", padding: "25px 30px", borderRadius: "12px", minWidth: "350px", boxShadow: "0 8px 25px rgba(0,0,0,0.3)", textAlign: "center" }}>
                        <h3 style={{ marginTop: 0, marginBottom: "20px", color: "#333", fontWeight: "600", fontSize: "18px" }}>?? Enter Collected Amount</h3>
                        <div style={{ marginBottom: "15px", textAlign: "left" }}>
                            <label style={{ fontWeight: 500, color: "#555" }}>Collected Amount:</label>
                            <input type="number" value={collectedAmount} placeholder="Enter Collected Amount"
                                onClick={(e) => { e.target.select(); }}
                                onChange={(e) => { const val = parseFloat(e.target.value) || 0; setCollectedAmount(val); setBalanceAmount(val - (parseFloat(formData.GrandTotal) || 0)); }}
                                style={{ width: "100%", padding: "10px", fontSize: "15px", marginTop: "6px", borderRadius: "6px", border: "1px solid #ccc", outline: "none", textAlign: "right" }}
                                onFocus={(e) => (e.target.style.borderColor = "#007bff")}
                                onBlur={(e) => (e.target.style.borderColor = "#ccc")}
                            />
                        </div>
                        <p style={{ fontWeight: "bold", color: balanceAmount >= 0 ? "#28a745" : "#dc3545", fontSize: "18px", marginBottom: "20px" }}>
                            Balance Amount: ?{balanceAmount.toFixed(2)}
                        </p>
                        <button onClick={() => { setShowModal(false); handleSubmit({ preventDefault: () => { } }); }}
                            style={{ backgroundColor: "#007bff", color: "#fff", border: "none", padding: "10px 20px", borderRadius: "8px", fontSize: "15px", cursor: "pointer" }}
                            onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
                            onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}>
                            OK
                        </button>
                    </div>
                </div>
            )}

        </div>
    );
}
export default ProformaCreate;